import { uniqueId } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

/**********
 * 热点分析
 ***********/

// 热点问题列表服务端数据格式
function queryHotQues2Server(reqData) {
    let request = {
        start_time: reqData.startTime,
        end_time: reqData.endTime,
        page: reqData.page,
        size: reqData.curPageLen,
        set_id: reqData.sceneId,
        channel: getServerComData(reqData).channel,
        question_type: getServerComData(reqData).question,
        language: getServerComData(reqData).lang
    };

    return request;
}

// 热点问题列表客户端数据格式
function hotQuesData2Client(result) {
    let data = {
        allQuesNum: result.all_question_count,
        count: result.count,
        hotQuesData: []
    };
    data.hotQuesData =
        result &&
        result.list.map(item => {
            return {
                id: uniqueId(),
                ranking: item.question_rank,
                question: { value: item.question, tips: i18n.t("zhiji.hotSpot.quesTip"), disabled: item.is_self },
                questionNum: item.question_count,
                proportion: item.question_rate,
                rowId: item.question_id,
                addData: {
                    rowId: item.question_id,
                    sceneId: item.set_id
                }
            };
        });

    return data;
}

// 场景热点列表服务端数据转换
function queryHotScene2Server(reqData) {
    let request = {
        start_time: reqData.startTime,
        end_time: reqData.endTime,
        page: reqData.page,
        size: reqData.curPageLen,
        set_level: reqData.sceneLevel,
        channel: getServerComData(reqData).channel,
        question_type: getServerComData(reqData).question,
        language: getServerComData(reqData).lang
    };

    return request;
}

// 问题热点-场景服务端数据转换
function querySortSetInfo2Server(reqData) {
    let request = {
        start_time: reqData.startTime,
        end_time: reqData.endTime,
        channel: getServerComData(reqData).channel,
        question_type: getServerComData(reqData).question,
        language: getServerComData(reqData).lang
    };

    return request;
}

// 转换热点分析筛选字段
function getServerComData(reqData) {
    const questionObj = {"all": "", "initQues": "first_ask", "input": "input", "click": "click"}
    return {
        channel: !!reqData.channelType && reqData.channelType === "all" ? "" : reqData.channelType,
        question: questionObj[reqData.quesType] || "",
        lang: !!reqData.langType && reqData.langType === "all" ? "" : reqData.langType
    };
}

// 场景热点列表客户端数据格式
function hotSceneData2Client(result) {
    let data = {
        count: result.count,
        hotSceneData: []
    };
    data.hotSceneData =
        result &&
        result.list.map(item => {
            return {
                id: uniqueId(),
                ranking: item.question_rank,
                classify: item.set_name,
                questionNum: item.question_count,
                proportion: item.question_rate
            };
        });
    return data;
}

export default {
    queryHotQues2Server,
    hotQuesData2Client,
    queryHotScene2Server,
    hotSceneData2Client,
    querySortSetInfo2Server
};
